var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9516 8.34783C19.1436 8.34783 19.2994 8.1927 19.2994 8C19.2994 7.92696 19.2764 7.8567 19.2347 7.79757L16.7304 4.29148C16.5996 4.10852 16.3881 4 16.1634 4H12.5217C12.3297 4 12.1738 4.15583 12.1738 4.34783V8C12.1738 8.192 12.3297 8.34783 12.5217 8.34783H18.9516Z",
    fill: "#A096D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.73913C4 9.54713 4.15583 9.3913 4.34783 9.3913H19.6522C19.8442 9.3913 20 9.54713 20 9.73913V19.3043C20 19.6883 19.6883 20 19.3043 20H4.69565C4.31165 20 4 19.6883 4 19.3043V9.73913ZM12.6957 15.8261C12.5037 15.8261 12.3478 15.9819 12.3478 16.1739V17.5652C12.3478 17.7572 12.5037 17.913 12.6957 17.913H17.5652C17.7572 17.913 17.913 17.7572 17.913 17.5652V16.1739C17.913 15.9819 17.7572 15.8261 17.5652 15.8261H12.6957Z",
    fill: "#7267B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1305 4.34783C11.1305 4.15583 10.9747 4 10.7827 4H7.83658C7.61189 4 7.40041 4.10852 7.26962 4.29148L4.76528 7.79757C4.65328 7.95409 4.68945 8.17113 4.84597 8.28313C4.9051 8.32487 4.97536 8.34783 5.04841 8.34783H10.7827C10.9747 8.34783 11.1305 8.192 11.1305 8V4.34783Z",
    fill: "#A096D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsActive);
export default __webpack_public_path__ + "static/media/products-active.8a582199a89db20e637bc1743d2ba02f.svg";
export { ForwardRef as ReactComponent };